import React from "react";
import SFSearchField from "../../textField/search";
import getStyled from "../../../hooks/getStyled";
import PropTypes from "prop-types";

const { styled } = getStyled();

const StyledSFSearchField = styled(SFSearchField)(({ theme }) => ({
  "& fieldset": { border: "none" },
  "& .MuiSvgIcon-root": {
    color: theme.palette.grey400.main,
  },
}));

const SearchFilter = ({ searchFilter }) => {
  return (
    <StyledSFSearchField
      variant="outlined"
      size="small"
      placeholder={searchFilter?.placeholder}
      onChange={searchFilter?.onChange}
      initialValue={searchFilter?.searchTerm}
      hasClearBtn
    />
  );
};

export default SearchFilter;

/**
 * PropTypes definition for the SearchFilter component.
 * This component provides a search input field with styling.
 */
SearchFilter.propTypes = {
  /**
   * Configuration object for the search field.
   */
  searchFilter: PropTypes.shape({
    /**
     * Placeholder text displayed in the search field when empty.
     */
    placeholder: PropTypes.string.isRequired,

    /**
     * Handler function called when the search input changes.
     * @param {string} value - The new search text value.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * Current search term value to display in the search field.
     */
    searchTerm: PropTypes.string.isRequired,
  }).isRequired,
};
